import { FC, ReactNode, useState } from 'react';
import Search from 'Components/ShellHost/TopBar/Search/Search';
import { Checkbox } from 'antd';
import { Wrapper } from './styles';

export interface ITipoOption {
  description: string;
  renderNode?: ReactNode;
  value: string;
}

export interface ITipoFilter {
  hideSearch?: boolean;
  tipoOptions?: ITipoOption[];
  propsFilter: any;
  width?: string;
  placeholder?: string;
  className?: string;
  showFilter?: (display: boolean) => void;
}

const FilterModal: FC<ITipoFilter> = ({
  hideSearch,
  className,
  tipoOptions,
  width,
  propsFilter,
  placeholder,
  showFilter
}) => {
  const [searchInput, setSearchInput] = useState<string>();
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  const changeFilterValues = (value: string, checked: boolean) => {
    if (checked) {
      propsFilter.setSelectedKeys([...selectedKeys, value.toLowerCase()]);
      setSelectedKeys([...selectedKeys, value.toLowerCase()]);
    } else {
      const index = selectedKeys.indexOf(value.toLowerCase());
      selectedKeys.splice(index, 1);
      propsFilter.setSelectedKeys([...selectedKeys]);
      setSelectedKeys([...selectedKeys]);
    }
    propsFilter.confirm();
    if (showFilter) {
      showFilter(true);
    }
  };

  return (
    <Wrapper minwidth={width} className={className}>
      <Search
        placeholder={!placeholder ? 'Buscar formato' : placeholder}
        className={`searchTipo ${hideSearch ? 'hide' : ''}`}
        value={searchInput}
        changeValue={setSearchInput}
      />
      <div className="tipoOptionsWrap">
        {tipoOptions?.filter(
          (tipoOption) => tipoOption.description.toLocaleLowerCase().includes(searchInput?.toLocaleLowerCase() || ''))
          .map((tipoOption) => (
            <div
              className="tipoOption"
              key={tipoOption.description}
              onClick={(e) => {
                e.currentTarget.getElementsByTagName('input').item(0)?.click();
              }}
            >
              <Checkbox
                className="checkbox"
                onChange={(props: any) =>
                  changeFilterValues(props.target.value, props.target.checked)
                }
                checked={propsFilter.selectedKeys.includes(tipoOption.value.toLowerCase())}
                value={tipoOption.value}
              />
              {tipoOption.renderNode ? (
                tipoOption.renderNode
              ) : (
                <span className="description">{tipoOption.description}</span>
              )}
            </div>
          ))
        }
      </div>
    </Wrapper>
  );
};

export default FilterModal;
